import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "revico-community-talk-talkroom" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "revico-community-talk-talkroom--title" }, "トークルーム一覧", -1 /* HOISTED */)
const _hoisted_3 = { class: "revico-community-talk-talkroom-list" }
const _hoisted_4 = ["data-display-talkroom-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.talkRooms, (talkRoom, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "revico-community-talk-talkroom-list-item",
          "data-display-talkroom-id": talkRoom.displayTalkRoomId
        }, [
          _createVNode($setup["TalkRoomMaster"], {
            talkRoom: talkRoom,
            wordSettings: $props.wordSettings,
            communityTalkStoreKey: $props.communityTalkStoreKey
          }, null, 8 /* PROPS */, ["talkRoom", "wordSettings", "communityTalkStoreKey"])
        ], 8 /* PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}